// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/ChatMessage.test.tsx

/** The line the review skill reads. It stays on the stored message. */
const REVIEW_IDS_LINE = /^\s*\*\*Review ids:\*\*/i;

/**
 * The text a chat bubble draws.
 *
 * why: `Review ids` is how the skill keeps the English ids after the names
 * are translated. That line is not for the person reading the thread.
 */
export function visibleChatText(content: string): string {
  if (!content.includes("Review ids")) return content;
  return content
    .split("\n")
    .filter((line) => !REVIEW_IDS_LINE.test(line))
    .join("\n");
}
